import React from 'react';
import { connect } from 'react-redux';
import { Main } from '../../containers/main';

const AuthWrapper = () => {
	return <Main />;
};

export const Auth = connect()(AuthWrapper);
